<template>
  <div :class="[size]">
    <div
      v-if="static"
      class="loader spinner-border"
      :class="{
        'overlay-visible': showOverlay,
      }"
    />

    <div
      v-else
      class="overlay"
      :class="[
        {
          inner,
          'overlay-visible': showOverlay,
        },
      ]"
      :style="customStyle"
    >
      <div class="vertically-centered-old">
        <div>
          <p v-if="text">{{ text }}</p>
          <i class="loader spinner-border" />
          <!-- <i class="faded-spinner" :class="{ 'refresh-spinner': small }" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    inner?: boolean // if set, positions relative to the closest parent with position-relative
    text?: string
    size?: 'large' | 'medium' | 'small'

    // whether to display the white semi-opaque overlay
    // off as default when using inner, on when not. not available when static is used
    overlay?: boolean
    static?: boolean // positioned statically with the normal flow
    // autofit?: boolean // sets min-height of top level element equal to the loader height to make the whole loader is shown when it's not positioned statically
    customStyle?: string
  }>(),
  {
    size: 'large',
  },
)

const showOverlay = computed(() => {
  if (props.inner || props.static) {
    return props.overlay === true
  }
  return props.overlay !== false
})
</script>

<style lang="scss" scoped>
// used to position the loader. is click-through unless the overlay-visible class is also used
.overlay {
  position: fixed;
  z-index: 2;
  display: flex;
  // padding-top: 2em;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  background-color: transparent;
  justify-content: center;
  pointer-events: none;
}

.overlay-visible {
  background-color: #fffa;
  pointer-events: all;
}

.loader {
  z-index: 1;
}

.inner {
  position: absolute; // overwrites positional-overlay display
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.vertically-centered {
  display: flex;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.vertically-centered-old {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  p {
    text-shadow: 1px 1px 2px white;
  }
}

.large {
  $size: 4rem;

  // &.autofit {
  //   min-height: $size;
  // }

  .loader {
    width: $size;
    height: $size;
  }
}

.medium {
  $size: 2rem;

  // &.autofit {
  //   min-height: $size;
  // }

  .loader {
    width: $size;
    height: $size;
    border-width: 2px !important;
  }
}

.small {
  $size: 1rem;
  // &.autofit {
  //   min-height: $size;
  // }

  .loader {
    width: $size;
    height: $size;
    border-width: 1px !important;
  }
}
</style>
